import img_1 from "../../assets/images/storeImages/Web_Coffee.png";
import img_2 from "../../assets/images/storeImages/Web_DELICIOUS_chicken.png";
import img_3 from "../../assets/images/storeImages/Web_Gym_COACHING.png";
import img_4 from "../../assets/images/storeImages/Web_HOTEL_HOTUX.png";
import img_5 from "../../assets/images/storeImages/Web_Modern_Interior_Design_Studio.png";
import webCoffee from "../../assets/images/storeImages/Web_Pet_Care_Service_Company.png";
import webDeliciousChicken from "../../assets/images/storeImages/Web_Phe_Lieu.png";
import webGymCoaching from "../../assets/images/storeImages/Web_ShopE.png";
import webHotelHotux from "../../assets/images/storeImages/Web_SNACK_LOUD.png";
import webModernInteriorDesignStudio from "../../assets/images/storeImages/Web_Coffee.png";
import webPetCareServiceCompany from "../../assets/images/storeImages/Web_DELICIOUS_chicken.png";
import webPheLieu from "../../assets/images/storeImages/Web_Gym_COACHING.png";
import webShopE from "../../assets/images/storeImages/Web_HOTEL_HOTUX.png";
import webSnackLoud from "../../assets/images/storeImages/Web_Modern_Interior_Design_Studio.png";

export const discountFeatures = [
  "Tặng ngay tên miền hosting",
  "Hỗ trợ thay đổi thông tin tận tâm",
  "Tặng clip hướng dẫn sử dụng chi tiết",
  "Bảo hành website trọn đời",
];

export const Basic = [
  "Chọn mẫu giao diện thiết kế có sẵn",
  "Tùy chỉnh giao diện theo nhận diện thương hiệu",
  "Tối ưu hiển thị trên mọi thiết bị",
  "Tích hợp tính năng hiện đại, dễ sử dụng",
  "Hỗ trợ cập nhật nội dung nhanh chóng",
  "Bảo mật và tốc độ tải trang cao",
  "Tư vấn giải pháp phù hợp từng ngành nghề",
  "Bảo hành, hỗ trợ kỹ thuật trọn đời",
];

export const listImages = [
  { img: img_1, name: "Khách sạn - Du lịch" },
  { img: img_2, name: "Giáo dục - Khóa học" },
  { img: img_3, name: "Mẹ và bé" },
  { img: img_4, name: "Mỹ phẩm - Spa - Làm đẹp" },
  { img: img_5, name: "Thời trang - Trang sức" },
  { img: img_1, name: "Thực phẩm - Nhà hàng - Cafe" },
  { img: img_2, name: "Đồ gia dụng - Điện máy" },
  { img: img_3, name: "Nội thất - Trang trí" },
  { img: img_4, name: "Công nghệ - Startup" },
  { img: img_5, name: "Phương tiện giao thông" },
  { img: img_1, name: "Bất động sản - Xây dựng" },
  { img: img_2, name: "Y tế - Sức khỏe - TPCN" },
];

export const listProduct = [
  { img: webHotelHotux, name: "Web HOTEL HOTUX" },
  { img: webCoffee, name: "Web Coffee" },
  { img: webDeliciousChicken, name: "Web DELICIOUS Chicken" },
  { img: webGymCoaching, name: "Web GYM Coaching" },
  { img: webModernInteriorDesignStudio, name: "Web Modern Interior Design Studio" },
  { img: webPetCareServiceCompany, name: "Web Pet Care Service Company" },
  { img: webSnackLoud, name: "Web SNACK LOUD" },
  { img: webPheLieu, name: "Web Phế Liệu" },
  { img: webShopE, name: "Web ShopE" },
];
